import { SignUpPage } from '../pages/SignUpPage.tsx';
import { SecurityPage } from '../pages/SecurityPage.tsx';
import { TwoFactorPage } from '../pages/TwoFactorPage.tsx';
import { OnboardingPage } from '../pages/OnboardingPage.tsx';
import { RequireAccount } from './RequireAccount.tsx';
import { createBrowserRouter, Navigate } from 'react-router';
import { UsersPage, OrganizationsPage, ProductsPage, MailPage } from '@lumlab/platform-admin/web';
import { RequireProduct } from './RequireProduct.tsx';
import { RequireAdministrator } from './RequireAdministrator.tsx';
import { HomePage } from '../pages/HomePage.tsx';
import { NotFoundPage } from '../pages/NotFoundPage.tsx';
import { SignInPage } from '../pages/SignInPage.tsx';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage.tsx';
import { ResetPasswordPage } from '../pages/ResetPasswordPage.tsx';
import { VerifyEmailPage } from '../pages/VerifyEmailPage.tsx';
import { UnsubscribePage } from '../pages/UnsubscribePage.tsx';
import { products } from '../products.ts';
import { AppLayout } from './AppLayout.tsx';
import { RequireSession } from './RequireSession.tsx';

export const router = createBrowserRouter([
    { path: '/sign-in', element: <SignInPage /> },
    { path: '/sign-up', element: <SignUpPage /> },
    { path: '/two-factor', element: <TwoFactorPage /> },
    {
        path: '/security',
        element: (
            <RequireAccount securityRequired={false} onboardingRequired={false}>
                <SecurityPage />
            </RequireAccount>
        ),
    },
    {
        path: '/welcome',
        element: (
            <RequireAccount onboardingRequired={false}>
                <OnboardingPage />
            </RequireAccount>
        ),
    },
    // Reached from e-mails, without a session.
    { path: '/forgot-password', element: <ForgotPasswordPage /> },
    { path: '/reset-password', element: <ResetPasswordPage /> },
    { path: '/verify-email', element: <VerifyEmailPage /> },
    { path: '/unsubscribe', element: <UnsubscribePage /> },
    {
        path: '/admin',
        element: (
            <RequireAccount>
                <RequireSession organizationRequired={false}>
                    <RequireAdministrator>
                        <AppLayout administration />
                    </RequireAdministrator>
                </RequireSession>
            </RequireAccount>
        ),
        children: [
            { index: true, element: <Navigate to="users" replace /> },
            { path: 'users', element: <UsersPage /> },
            { path: 'organizations', element: <OrganizationsPage /> },
            { path: 'products', element: <ProductsPage products={products} /> },
            { path: 'mail', element: <MailPage /> },
            ...products.flatMap((product) =>
                product.administration
                    ? [{ path: `products/${product.id}`, children: product.administration.routes }]
                    : [],
            ),
            { path: '*', element: <NotFoundPage /> },
        ],
    },
    {
        path: '/',
        element: (
            <RequireAccount>
                <RequireSession>
                    <AppLayout />
                </RequireSession>
            </RequireAccount>
        ),
        children: [
            { index: true, element: <HomePage /> },
            ...products.map((product) => ({
                path: product.id,
                element: <RequireProduct productId={product.id} />,
                children: product.routes,
            })),
            { path: '*', element: <NotFoundPage /> },
        ],
    },
]);
